<template>
  <button
    class="flex items-center justify-center rounded-full p-3 hover:bg-gray-600_a25 active:bg-gray-600_a35"
    :title="t('search-menu.placeholder')"
    @click="handleClick"
  >
    <IconSearch class="h-6 w-6" />
  </button>
</template>

<script setup lang="ts">
  const { t } = useI18n();
  const searchMenuStore = useSearchMenuStore();
  const { isMenuOpen } = storeToRefs(searchMenuStore);

  const handleClick = (): void => {
    isMenuOpen.value = true;
  };
</script>
